import { DisplayMessage } from "../helpers";
import { DeleteRequest, GetRequest, UpdateRequest } from "../requestHelpers";
import { HttpMethods } from "../../utils/constants";
import {
  GetTraitsUrl,
  TraitsUrl,
  GetTraitByIdUrl,
  UpdateTraitUrl,
  DeleteTraitUrl,
} from "../../constants/apiUrls";

export const getTraits = async () => {
  const response = await GetRequest(GetTraitsUrl());
  let result = await response.json();
  if (!response.ok) {
    for (let i = 0; i < result.errors.length; i++) {
      DisplayMessage(result.errors[i], "error");
    }
    return null;
  }
  return result;
};

export const getTraitById = async (id) => {
  const response = await GetRequest(GetTraitByIdUrl(id));
  let result = await response.json();
  if (!response.ok) {
    for (let i = 0; i < result.errors.length; i++) {
      DisplayMessage(result.errors[i], "error");
    }
    return null;
  }
  return result;
};

export const createTrait = async (data) => {
  const response = await UpdateRequest(TraitsUrl(), data, HttpMethods.Post);
  if (!response.ok) {
    const result = await response.json();
    for (let i = 0; i < result.errors.length; i++) {
      DisplayMessage(result.errors[i], "error");
    }
    return undefined;
  }
  return await response.json();
};

export const updateTrait = async (id, data) => {
  const response = await UpdateRequest(
    UpdateTraitUrl(id),
    data,
    HttpMethods.Patch
  );
  if (!response.ok) {
    const result = await response.json();
    for (let i = 0; i < result.errors.length; i++) {
      DisplayMessage(result.errors[i], "error");
    }
    return false;
  }
  return true;
};

export const deleteTrait = async (id) => {
  const response = await DeleteRequest(DeleteTraitUrl(id));

  if (!response.ok) {
    response.json().then((result) => {
      for (let i = 0; i < result.errors.length; i++) {
        DisplayMessage(result.errors[i], "error");
      }
    });
  }

  return response.ok;
};
